(() => {
  'use strict';

  const root = document.querySelector('[data-cuvvo-cart-page]');
  if (!root || window.__cuvvoCartPageLoaded) return;
  window.__cuvvoCartPageLoaded = true;

  const checkout = root.querySelector('[data-cuvvo-checkout]');
  const checkoutText = checkout?.querySelector('[data-cuvvo-checkout-text]');

  if (checkout) {
    checkout.addEventListener('click', () => {
      checkout.setAttribute('aria-busy', 'true');
      if (checkoutText) checkoutText.textContent = 'Opening Checkout…';
    });

    window.addEventListener('pageshow', () => {
      checkout.removeAttribute('aria-busy');
      if (checkoutText) checkoutText.textContent = 'Continue to Checkout';
    });
  }

  const resetLink = root.querySelector('[data-cuvvo-reset-cart]');
  const status = root.querySelector('[data-cuvvo-cart-status]');

  if (resetLink) {
    resetLink.addEventListener('click', async (event) => {
      event.preventDefault();
      if (resetLink.getAttribute('aria-busy') === 'true') return;

      const destination = resetLink.href;
      const originalText = resetLink.textContent;
      resetLink.setAttribute('aria-busy', 'true');
      resetLink.textContent = 'Preparing Your Selection…';
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      try {
        const rootPath = String(window.Shopify?.routes?.root || '/');
        const base = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;
        const response = await fetch(`${base}cart/clear.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) throw new Error('Cart reset failed');
        window.location.assign(destination);
      } catch (_) {
        resetLink.removeAttribute('aria-busy');
        resetLink.textContent = originalText;
        if (status) {
          status.textContent = 'We could not reset the cart safely. Please try again.';
          status.hidden = false;
        }
      }
    });
  }
})();
